import {
  AccordionItem,
  AccordionHeader,
  AccordionTrigger,
  AccordionTitleText,
  AccordionIcon,
  AccordionContent,
} from "ui/gluestack/accordion";
import { ChevronUpIcon, ChevronDownIcon } from "ui/gluestack/icon";
import { Text, View } from "react-native";
import { FluidIntakeReportResponse } from "app/services/api/types/forms/responses/FluidIntakeReportResponse";
import { format } from "date-fns";
import KeyValueGrid from "ui/organisms/KeyValueGrid";
import { useMemo } from "react";
import { getFullName } from "ui/utils/nameUtil";

interface Props {
  log: FluidIntakeReportResponse;
}

export function FluidIntakeHistoryItem({ log }: Props) {
  const intakeLogs = useMemo(
    () => [
      { label: "Consumed Amount", value: `${log.consumed_amount} ml` },
      { label: "Intake Method", value: `${log.intake_method} ml` },
      {
        label: "Additional Information",
        value: log.additional_information || "N/A",
      },
      { label: "Recorded by", value: getFullName(log.user) || "N/A" },
    ],
    [log],
  );
  return (
    <AccordionItem
      key={log.id}
      value={`${log.id}`}
      className="border rounded-lg border-border-200 p-2"
    >
      <AccordionHeader>
        <AccordionTrigger className="focus:web:rounded-lg">
          {({ isExpanded }) => (
            <>
              <View className="flex-row items-center">
                <AccordionTitleText className="mr-1">
                  {log.fluid_type}
                </AccordionTitleText>
                <Text className="text-xs font-medium text-typography-600">
                  - {format(new Date(log.recorded_at), "dd-MM-yyyy 'at' HH:mm")}
                </Text>
              </View>
              {isExpanded ? (
                <AccordionIcon as={ChevronUpIcon} />
              ) : (
                <AccordionIcon as={ChevronDownIcon} />
              )}
            </>
          )}
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent>
        <View>
          <KeyValueGrid items={intakeLogs} />
        </View>
      </AccordionContent>
    </AccordionItem>
  );
}
